import { cn } from "../utils";
import { Label } from "./label";
import type { ReactNode } from "react";

interface FieldWrapperProps {
  label?: string;
  helperText?: string;
  error?: string;
  className?: string;
  id?: string;
  children: ReactNode;
}

export function FieldWrapper({
  label,
  helperText,
  error,
  className,
  id,
  children,
}: FieldWrapperProps) {
  return (
    <div className={className}>
      {label && <Label htmlFor={id}>{label}</Label>}
      <div className={cn(label && "mt-2")}>{children}</div>
      {(helperText || error) && (
        <p
          className={cn(
            "mt-2 text-sm",
            error ? "text-red-600" : "text-slate-500",
          )}
        >
          {error || helperText}
        </p>
      )}
    </div>
  );
}
